import { Box, Flex, Text } from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { FilterDropdownProps } from '../useFilterConfigs';
import Picker1 from '../../../../../core/components/pickers/Picker1';

interface FilterColorDropdownProps extends Pick<FilterDropdownProps, 'stroke'> {
  Icon: IconType;
  color: string;
  colors: string[];
  changeColor: (color: string) => void;
}
export default function FilterColorDropdown({
  Icon,
  color,
  colors,
  stroke,
  changeColor,
}: FilterColorDropdownProps) {
  const colorView = (color: string) => (
    <Flex key={color} alignItems="center">
      <Box
        h="20px"
        w="20px"
        rounded="100%"
        border={`1px solid ${stroke}`}
        bg={color}
      />
      <Text ml="2">{color.toUpperCase()}</Text>
    </Flex>
  );

  const menu = (
    <Picker1.Menu>
      <Picker1.MenuButton
        Icon={<Icon />}
        TitleView={color.length && colorView(color)}
        title={color.length ? '' : 'None'}
      />
      <Picker1.MenuList<string>
        includeNone
        selectedValue={color}
        options={colors}
        changeValue={changeColor}
        customOptionView={colorView}
      />
    </Picker1.Menu>
  );

  return menu;
}
